/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Account_Delivery_Telegram_TitleInputs */

const he_account_delivery_telegram_title = /** @type {(inputs: Account_Delivery_Telegram_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`טלגרם`)
};

const en_account_delivery_telegram_title = /** @type {(inputs: Account_Delivery_Telegram_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Telegram`)
};

/**
* | output |
* | --- |
* | "Telegram" |
*
* @param {Account_Delivery_Telegram_TitleInputs} inputs
* @param {{ locale?: "he" | "en" }} options
* @returns {LocalizedString}
*/
export const account_delivery_telegram_title = /** @type {((inputs?: Account_Delivery_Telegram_TitleInputs, options?: { locale?: "he" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Account_Delivery_Telegram_TitleInputs, { locale?: "he" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "he") return he_account_delivery_telegram_title(inputs)
	return en_account_delivery_telegram_title(inputs)
});